import { render, staticRenderFns } from "./BtnReferences.vue?vue&type=template&id=0c0547b0&scoped=true&"
import script from "./BtnReferences.vue?vue&type=script&lang=js&"
export * from "./BtnReferences.vue?vue&type=script&lang=js&"
import style0 from "./BtnReferences.vue?vue&type=style&index=0&id=0c0547b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0547b0",
  null
  
)

export default component.exports